import React, { useEffect } from "react";
import { RydMusic } from "../../music/RydMusic";
import { TonalityInputBox } from "../pickers/ContextTonality";
import { ApiFactory } from "../../ApiClient";
import { RydScaleInfobox } from "../inspector/RydScaleInfobox";
import { RydChordInfobox } from "../inspector/RydChordInfobox";
import { Tonality } from "../../model/scales";
import { Chord } from "../../model/core";


const API = ApiFactory.create();

function RydChordSelector({
    scale
}: {
    scale?: Tonality
}) {

    const [selectedScale, setSelectedScale] = React.useState<Tonality | undefined>(scale);
    const [selectableChords, setSelectableChords] = React.useState<Chord[][]>([]);
    const [selectedChord, setSelectedChord] = React.useState<Chord | undefined>(undefined);

    useEffect(() => {
        if (!selectedScale) return;

        const chords = Promise.all(RydMusic.DiatonicChords.buildFromScale(
            (notes: number[]) => API.getChordIdByNotes(notes),
            selectedScale
        ).map(Promise.all, Promise)).then(_chords => {
            const chords: Chord[][] = _chords.map(cs =>
                cs.map((c: Chord) => API.loadChord(c))
                    .filter(c => c !== undefined) as Chord[]
            );
            setSelectableChords(chords);
        });
    }, [selectedScale]);

    return (<div>
        Scale: <TonalityInputBox
            tonality={selectedScale}
            setTonalityCB={(t: Tonality) => {
                setSelectedScale(t);
            }}
        />

        Scale: {selectedScale && <RydScaleInfobox tonality={selectedScale} />}
        Chords:
        <table>
            <tbody>
                {selectableChords?.map((nAdicChords: Chord[], i) =>

                    <tr key={i}>
                        {nAdicChords.map((c: Chord, i) =>
                            <td key={i} onClick={() => setSelectedChord(c)}>{c.getName()}</td>)}
                    </tr>
                )}
            </tbody>
        </table>

        Chord details: {selectedChord && <RydChordInfobox chord={selectedChord} />}
    </div>);

}

export {
    RydChordSelector
};